document.addEventListener("DOMContentLoaded", function () {
    const thumbnails = document.querySelectorAll(".thumbnail-img");
    const mainMedia = document.querySelectorAll(".main-media");
    const prevArrow = document.querySelector(".prev-arrow");
    const nextArrow = document.querySelector(".next-arrow");
    const variantSelectors = document.querySelectorAll("[name='id']");
    let currentIndex = 0;

    function updateActiveMedia(index) {
        mainMedia.forEach((media) => {
            media.classList.remove("active");

            if (media.tagName === "VIDEO") {
                media.pause();
                media.currentTime = 0;
            }
        });

        thumbnails.forEach((thumb) => thumb.classList.remove("active"));

        const selectedMedia = mainMedia[index];
        selectedMedia.classList.add("active");
        thumbnails[index].classList.add("active");

        // Ensure video source is set correctly
        if (selectedMedia.tagName === "VIDEO") {
            let videoSrc = selectedMedia.getAttribute("data-src");
            if (videoSrc && !selectedMedia.src) {
                selectedMedia.src = videoSrc;
            }
            selectedMedia.play();
        }

        currentIndex = index;
    }

    thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener("click", function () {
            updateActiveMedia(index);
        });
    });

    nextArrow.addEventListener("click", function () {
        let newIndex = (currentIndex + 1) % mainMedia.length;
        updateActiveMedia(newIndex);
    });

    prevArrow.addEventListener("click", function () {
        let newIndex = (currentIndex - 1 + mainMedia.length) % mainMedia.length;
        updateActiveMedia(newIndex);
    });

    // ✅ **New Function: Update Media on Variant Selection**
    function updateVariantImages(variantId) {
        fetch(window.location.pathname + `.json`)
            .then((response) => response.json())
            .then((data) => {
                const variant = data.product.variants.find(v => v.id == variantId);
                if (variant && variant.featured_image) {
                    // ✅ Update main media
                    document.querySelector(".main-media.active").src = variant.featured_image.src;

                    // ✅ Hide all thumbnails
                    thumbnails.forEach((thumb) => thumb.classList.add("hidden"));

                    // ✅ Show only relevant thumbnails
                    thumbnails.forEach((thumb) => {
                        if (thumb.dataset.variantId == variantId) {
                            thumb.classList.remove("hidden");
                        }
                    });

                    // ✅ Reset active media
                    updateActiveMedia(0);
                }
            })
            .catch((error) => console.error("Error fetching variant data:", error));
    }

    // ✅ **Attach Event Listener to Variant Select**
    if (variantSelectors.length) {
        variantSelectors.forEach((selector) => {
            selector.addEventListener("change", function () {
                updateVariantImages(this.value);
            });
        });
    }

    // Initialize first media item as active
    updateActiveMedia(0);


      const shopPayButton = document.querySelector(".shopify-payment-button button");

    if (shopPayButton) {
        shopPayButton.innerText = "Buy Instantly"; // Change this text
    }
});


